// extracted by mini-css-extract-plugin
export default {"wrap":"Kr-z","fullWidth":"Lr-z","items":"Mr-z","featureCss":"Nr-z","disabled":"Or-z","imgCss":"Pr-z"};